import { useEffect, useState } from 'react'
import { getDiscoveries } from '../lib/api'
import type { Discovery } from '../lib/types'
import RiskDot from '../components/RiskDot'

export default function Discover() {
  const [items, setItems] = useState<Discovery[]>([])
  const [loading, setLoading] = useState(true)
  const load = async () => { setLoading(true); try { setItems(await getDiscoveries()) } finally { setLoading(false) } }
  useEffect(() => { load() }, [])
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-white text-lg font-semibold">新发现瓶颈 <span className="text-muted text-sm font-normal">· {items.length} 个</span></h2>
        <button onClick={load} disabled={loading} className="text-muted text-sm hover:text-white disabled:opacity-50">{loading ? '刷新中...' : '↻ 刷新'}</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(d => (
          <div key={d.id} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="text-white font-medium text-sm">{d.name}</div>
                <div className="text-muted text-xs mt-0.5">{d.sector} · {d.pattern_matched}</div>
              </div>
              <RiskDot level={d.risk_level} />
            </div>
            <div className="flex items-center gap-3 mt-3">
              <span className="text-teal font-semibold text-2xl">{d.composite_score}</span>
              <span className="text-muted text-xs">综合分</span>
              <span className="ml-auto text-blue text-xs px-2 py-0.5 bg-blue/10 rounded">{d.status}</span>
            </div>
            {d.why_bottleneck && <p className="text-muted text-xs mt-3 line-clamp-2 leading-relaxed">{d.why_bottleneck}</p>}
          </div>
        ))}
        {!loading && items.length === 0 && <div className="text-muted py-12 text-center col-span-2">暂无发现</div>}
      </div>
    </div>
  )
}
